module.exports = __webpack_public_path__ + "img/logo-colorido.355feb55.png";